import {BackgroundModule} from '@fantasmagames/slot/src/modules/background/BackgroundModule';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';
import {GameBackgroundView} from 'src/background/GameBackgroundView';

export class GameBackgroundModule extends BackgroundModule {
	public static readonly TRANSITION_ANIMATION_STARTED: string = 'GameBackgroundModule::TRANSITION_ANIMATION_STARTED';
	public restore(): void {
		super.restore();

		if (this.logic.isFreeSpinsStarted) {
			this.gameView.isInFreeSpins = true;
			this.gameView.setupIdleAnimations();
			this.gameView.showFreeSpinsBackground();
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED, this.onFreeSpinsFinished);
		this.on(FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsContinueClicked);

		this.on(StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
		this.on(StartScreenEvents.EXIT_FINISHED, this.onStartScreenExitFinished);

		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
	}

	protected onFreeSpinsIntroStarted(): void {
		this.gameView.isInFreeSpins = true;
		this.gameView.setupIdleAnimations();
		this.gameView.hideReelBackground();
	}

	protected onFreeSpinsOutroStarted(): void {
		this.gameView.isInFreeSpins = false;
		this.gameView.setupIdleAnimations();
		this.gameView.hideReelBackground();
	}

	protected onFreeSpinsIntroFinished(): void {
		this.gameView.showReelBackground();
	}

	protected onFreeSpinsOutroFinished(): void {
		this.gameView.showReelBackground();
	}

	protected onStartScreenIntroStarted(): void {
		this.gameView.playStartAnimation();
		this.gameView.setReelsBackgroundAlphaToZero();
	}

	protected onFreeSpinsStarted(): void {
		this.gameView.playEnterFreeSpinsAnimation();
		this.gameView.showFreeSpinsBackground();
	}

	protected onFreeSpinsFinished(): void {
		this.gameView.playExitFreeSpinsAnimation();
		this.gameView.showMainGameBackground();
	}

	protected onStartScreenExitFinished(): void {
		this.eventManager.emit(GameBackgroundModule.TRANSITION_ANIMATION_STARTED);
		this.gameView.startTransition();
	}

	protected onFreeSpinsContinueClicked(): void {
		this.gameView.showFreeSpinsBackground();
	}

	public get gameView(): GameBackgroundView {
		return this._view as GameBackgroundView;
	}
}



// WEBPACK FOOTER //
// ./src/background/GameBackgroundModule.ts